import { render, staticRenderFns } from "./handleEleCard.vue?vue&type=template&id=6561ffcd&scoped=true"
import script from "./handleEleCard.vue?vue&type=script&lang=js"
export * from "./handleEleCard.vue?vue&type=script&lang=js"
import style0 from "./handleEleCard.vue?vue&type=style&index=0&id=6561ffcd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561ffcd",
  null
  
)

export default component.exports